<template>
  <div>
    <p
      v-if="message.content.type === 'text'"
      class="text-text-neutral-primary"
      v-html="formattedText"
    ></p>
    <div v-else-if="message.content.type === 'offers'" class="w-full space-y-3">
      <SearchResultCard
        v-for="(offer, index) in message.content.items"
        :key="offer.id"
        :offer-idx="index"
        :offer="offer"
        :is-recommended-sorting-mode="false"
        :is-favorite="false"
        is-favorite-disabled
        is-multi-trip-search
        @click="onOfferClick(offer)"
        @onCashbackInfoClick="emit('onCashbackInfoClick')"
      >
        <template #bottomExtra>
          <div
            v-if="
              offer.pros &&
              offer.pros.length > 0 &&
              offer.cons &&
              offer.cons.length > 0
            "
            class="bg-background-neutral-onblock flex gap-2 rounded-xl px-2 py-2"
          >
            <img
              src="@/entities/casbhack-info/assets/star.svg"
              width="20"
              height="20"
              class="h-5 w-5 shrink-0"
              alt=""
            />
            <div class="flex flex-col space-y-0.5">
              <p v-if="offer.pros.length > 0" class="text-sm">
                <span class="text-text-positive-primary font-medium"
                  >{{ t('aiChat.pros') }}: </span
                ><span class="text-text-neutral-primary lowercase">{{
                  offer.pros.join(', ')
                }}</span>
              </p>
              <p v-if="offer.cons.length > 0" class="text-sm">
                <span class="text-text-positive-primary font-medium"
                  >{{ t('aiChat.cons') }}: </span
                ><span class="text-text-neutral-primary lowercase">{{
                  offer.cons.join(', ')
                }}</span>
              </p>
            </div>
          </div>
        </template>
      </SearchResultCard>
    </div>
    <div v-else-if="message.content.type === 'ticketon'" class="space-y-3">
      <article
        v-for="ticketonItem in message.content.items"
        :key="ticketonItem.id"
        class="bg-background-neutral-secondary border-situational-lightgrey w-full overflow-hidden rounded-2xl border"
      >
        <div
          class="bg-background-neutral-tertiary flex h-28 w-full items-center justify-center"
        >
          <img
            v-if="ticketonItem.photo_url"
            :src="ticketonItem.photo_url"
            :alt="ticketonItem.title"
            class="h-full w-full object-cover"
          />
          <span v-else class="text-text-neutral-tertiary text-xs"
            >Ticketon</span
          >
        </div>
        <div class="space-y-2 p-3">
          <div class="flex items-start justify-between gap-2">
            <h4 class="text-text-neutral-primary font-semibold leading-5">
              {{ ticketonItem.title }}
            </h4>
            <span
              v-if="ticketonItem.is_hot"
              class="bg-background-warning-invisible text-text-warning-primary text-2xs shrink-0 rounded-xl px-2 py-0.5 font-medium"
            >
              Hot
            </span>
          </div>
          <p class="text-text-neutral-secondary text-xs">
            <span class="inline-flex items-center gap-1.5">
              <svg
                class="text-situational-darkgrey h-4 w-4 shrink-0"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10 3.33268C6.77834 3.33268 4.16667 5.94435 4.16667 9.16602C4.16667 11.0044 5.28006 12.7227 6.83743 14.0724L9.70528 16.5578C9.87442 16.7044 10.1256 16.7044 10.2947 16.5578L13.1626 14.0724C14.7199 12.7227 15.8333 11.0044 15.8333 9.16602C15.8333 5.94435 13.2217 3.33268 10 3.33268ZM2.5 9.16602C2.5 5.02388 5.85786 1.66602 10 1.66602C14.1421 1.66602 17.5 5.02388 17.5 9.16602C17.5 11.688 15.9919 13.8258 14.2541 15.3319L11.3863 17.8173C10.5907 18.5068 9.40931 18.5068 8.61373 17.8173L5.74588 15.3319C4.00814 13.8258 2.5 11.688 2.5 9.16602Z"
                  fill="currentColor"
                />
                <path
                  d="M11.6693 9.16667C11.6693 10.0871 10.9231 10.8333 10.0026 10.8333C9.08213 10.8333 8.33594 10.0871 8.33594 9.16667C8.33594 8.24619 9.08213 7.5 10.0026 7.5C10.9231 7.5 11.6693 8.24619 11.6693 9.16667Z"
                  fill="currentColor"
                />
              </svg>
              <span>
                {{
                  [ticketonItem.city, ticketonItem.venue]
                    .filter(Boolean)
                    .join(', ') || '-'
                }}
              </span>
            </span>
          </p>
          <p class="text-text-neutral-secondary text-xs">
            <span class="inline-flex items-center gap-1.5">
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="text-situational-darkgrey fill-situational-darkgrey"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.66667 2.5C7.1269 2.5 7.5 2.8731 7.5 3.33333V4.16667H12.5V3.33333C12.5 2.8731 12.8731 2.5 13.3333 2.5C13.7936 2.5 14.1667 2.8731 14.1667 3.33333V4.18928C14.239 4.19327 14.3089 4.19797 14.3765 4.2035C14.8449 4.24177 15.2755 4.3239 15.68 4.52998C16.3072 4.84956 16.8171 5.35949 17.1367 5.9867C17.3428 6.39115 17.4249 6.82173 17.4632 7.29015C17.5 7.74114 17.5 8.29476 17.5 8.96556V12.7011C17.5 13.3719 17.5 13.9255 17.4632 14.3765C17.4249 14.8449 17.3428 15.2755 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C15.2755 17.3428 14.8449 17.4249 14.3765 17.4632C13.9255 17.5 13.3719 17.5 12.7011 17.5H12.7011H12.7011H7.29894H7.29892H7.2989C6.6281 17.5 6.07447 17.5 5.62348 17.4632C5.15507 17.4249 4.72448 17.3428 4.32003 17.1367C3.69283 16.8171 3.18289 16.3072 2.86331 15.68C2.65724 15.2755 2.5751 14.8449 2.53683 14.3765C2.49998 13.9255 2.49999 13.3719 2.5 12.7011V12.7011V8.96559V8.96557C2.49999 8.29477 2.49998 7.74114 2.53683 7.29015C2.5751 6.82173 2.65724 6.39115 2.86331 5.9867C3.18289 5.35949 3.69283 4.84956 4.32003 4.52998C4.72448 4.3239 5.15507 4.24177 5.62348 4.2035C5.69111 4.19797 5.76104 4.19327 5.83333 4.18928V3.33333C5.83333 2.8731 6.20643 2.5 6.66667 2.5ZM5.7592 5.86463C5.39385 5.89448 5.20702 5.94858 5.07668 6.01499C4.76308 6.17478 4.50811 6.42975 4.34832 6.74335C4.28192 6.87368 4.22781 7.06052 4.19796 7.42587C4.19598 7.45011 4.19412 7.47481 4.19239 7.5H15.8076C15.8059 7.47481 15.804 7.45011 15.802 7.42587C15.7722 7.06052 15.7181 6.87368 15.6517 6.74335C15.4919 6.42975 15.2369 6.17478 14.9233 6.01499C14.793 5.94858 14.6061 5.89448 14.2408 5.86463C13.8657 5.83398 13.3805 5.83333 12.6667 5.83333H7.33333C6.61952 5.83333 6.13427 5.83398 5.7592 5.86463ZM4.16667 12.6667V9.16667H15.8333V12.6667C15.8333 13.3805 15.8327 13.8657 15.802 14.2408C15.7722 14.6061 15.7181 14.793 15.6517 14.9233C15.4919 15.2369 15.2369 15.4919 14.9233 15.6517C14.793 15.7181 14.6061 15.7722 14.2408 15.802C13.8657 15.8327 13.3805 15.8333 12.6667 15.8333H7.33333C6.61952 15.8333 6.13427 15.8327 5.7592 15.802C5.39385 15.7722 5.20702 15.7181 5.07668 15.6517C4.76308 15.4919 4.50811 15.2369 4.34832 14.9233C4.28192 14.793 4.22781 14.6061 4.19796 14.2408C4.16732 13.8657 4.16667 13.3805 4.16667 12.6667Z"
                  fill="currentColor"
                />
              </svg>
              <span>{{ formatTicketonStartsAt(ticketonItem.starts_at) }}</span>
            </span>
          </p>
          <div class="flex items-center justify-between gap-2 pt-1">
            <p class="text-text-neutral-primary text-sm font-semibold">
              {{ formatTicketonPrice(ticketonItem.price_from_kzt) }}
            </p>
            <button
              v-if="ticketonItem.deep_link"
              type="button"
              class="bg-button-primary-default text-button-content-primary rounded-xl px-3 py-2 text-xs font-medium"
              @click="onTicketonClick(ticketonItem)"
            >
              {{ t('aiChat.moreDetails') }}
            </button>
          </div>
        </div>
      </article>
    </div>
    <div v-else-if="message.content.type === 'trip_plan'" class="space-y-3">
      <article
        class="bg-background-neutral-secondary border-situational-lightgrey w-full overflow-hidden rounded-2xl border"
      >
        <div class="space-y-1 p-3">
          <h3 class="text-text-neutral-primary text-sm font-semibold">
            {{ message.content.plan.title }}
          </h3>
          <p
            v-if="message.content.plan.subtitle"
            class="text-text-neutral-secondary text-xs"
          >
            {{ message.content.plan.subtitle }}
          </p>
        </div>

        <ExpandableTransition
          v-for="day in message.content.plan.days"
          :key="`${day.date}-${day.day_number}`"
          class="border-situational-lightgrey border-t"
        >
          <template #action="{ isExpanded, open, close }">
            <div class="flex w-full items-start justify-between gap-2 p-3">
              <div class="space-y-1">
                <p class="text-text-neutral-primary text-sm font-medium">
                  {{ day.day_label }}
                </p>
                <p
                  v-if="day.district"
                  class="text-text-neutral-secondary text-xs"
                >
                  {{ day.district }}
                </p>
              </div>
              <div class="flex items-center justify-end gap-2">
                <span
                  v-if="typeof day.day_budget_kzt === 'number'"
                  class="bg-background-success-invisible text-text-positive-primary text-2xs shrink-0 rounded-xl px-2 py-0.5 font-medium"
                >
                  {{
                    t('aiChat.dayBudget', {
                      budget: formatBudget(day.day_budget_kzt),
                    })
                  }}
                </span>
                <button
                  type="button"
                  class="text-text-neutral-secondary flex h-6 w-6 shrink-0 items-center justify-center"
                  @click="isExpanded.value ? close() : open()"
                >
                  <svg
                    class="h-4 w-4 transition-transform"
                    :class="isExpanded.value ? 'rotate-180' : 'rotate-0'"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.33325 5.66699L7.99992 10.3337L12.6666 5.66699"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </template>
          <div class="space-y-2 px-3 pb-3">
            <article
              v-for="(block, blockIndex) in day.blocks"
              :key="`${day.date}-${blockIndex}`"
              class="bg-background-neutral-primary rounded-xl p-2"
            >
              <template v-if="block.kind === 'ai_note'">
                <p class="text-text-neutral-secondary text-xs">
                  {{ block.text }}
                </p>
              </template>
              <template v-else-if="block.kind === 'flight'">
                <p class="text-text-neutral-primary text-xs font-medium">
                  {{
                    block.time ? `${block.time} · ${block.title}` : block.title
                  }}
                </p>
                <p
                  v-if="block.subtitle"
                  class="text-text-neutral-secondary text-xs"
                >
                  {{ block.subtitle }}
                </p>
                <p
                  v-if="typeof block.cost_kzt === 'number'"
                  class="text-text-neutral-primary text-xs font-medium"
                >
                  {{
                    t('aiChat.blockBudget', {
                      budget: formatBudget(block.cost_kzt),
                    })
                  }}
                </p>
              </template>
              <template v-else-if="block.kind === 'place'">
                <p class="text-text-neutral-primary text-xs font-medium">
                  {{
                    block.time ? `${block.time} · ${block.title}` : block.title
                  }}
                </p>
                <p
                  v-if="block.description"
                  class="text-text-neutral-secondary mt-1 text-xs"
                >
                  {{ block.description }}
                </p>
                <div
                  v-if="block.tags && block.tags.length > 0"
                  class="mt-2 flex flex-wrap gap-1"
                >
                  <span
                    v-for="tag in block.tags"
                    :key="tag"
                    class="bg-background-neutral-tertiary text-text-neutral-secondary text-2xs rounded-lg px-2 py-0.5"
                  >
                    {{ tag }}
                  </span>
                </div>
                <p
                  v-if="typeof block.cost_kzt === 'number'"
                  class="text-text-neutral-primary mt-1 text-xs font-medium"
                >
                  {{
                    t('aiChat.blockBudget', {
                      budget: formatBudget(block.cost_kzt),
                    })
                  }}
                </p>
              </template>
              <template v-else-if="block.kind === 'event'">
                <p class="text-text-neutral-primary text-xs font-medium">
                  {{
                    block.time ? `${block.time} · ${block.title}` : block.title
                  }}
                </p>
                <p
                  v-if="block.venue"
                  class="text-text-neutral-secondary mt-1 text-xs"
                >
                  {{ block.venue }}
                </p>
                <p
                  v-if="block.why_relevant"
                  class="text-text-neutral-primary mt-1 text-xs"
                >
                  {{ block.why_relevant }}
                </p>
                <p
                  v-if="block.starts_at"
                  class="text-text-neutral-secondary mt-1 text-xs"
                >
                  {{ formatTicketonStartsAt(block.starts_at) }}
                </p>
                <p
                  v-if="block.description"
                  class="text-text-neutral-secondary mt-1 line-clamp-3 text-xs"
                >
                  {{ block.description }}
                </p>
                <p
                  v-if="typeof block.price_from_kzt === 'number'"
                  class="text-text-neutral-primary mt-1 text-xs font-medium"
                >
                  {{
                    t('aiChat.blockBudget', {
                      budget: formatBudget(block.price_from_kzt),
                    })
                  }}
                </p>
              </template>
            </article>
          </div>
        </ExpandableTransition>

        <footer
          v-if="totalBudgetLabel"
          class="bg-background-neutral-primary border-situational-lightgrey sticky bottom-0 border-t p-3"
        >
          <p class="text-text-neutral-primary text-sm font-semibold">
            {{ totalBudgetLabel }}
          </p>
        </footer>
      </article>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { marked } from 'marked';
  import { dateUtils, ExpandableTransition } from 'shared';
  import {
    freedomApp,
    SupportedMiniApps,
    amplitudeExperiment,
  } from 'freedom-shared';

  import { SearchResultCard } from '../../../search-result-card/ui';
  import { type AiChatMessage, type TicketonItem } from '../../api';

  const props = defineProps<{
    message: AiChatMessage;
  }>();
  const emit = defineEmits<{
    onClose: [];
    onCashbackInfoClick: [];
  }>();

  const router = useRouter();
  const { t } = useI18n();

  const { isVariant: isOpenVariant } =
    amplitudeExperiment.lib.checkExperimentVariant(
      amplitudeExperiment.config.flags.AI_CHAT_TICKETON_OPEN_METHOD,
      'open',
    );

  const formattedText = computed(() => {
    if (props.message.content.type !== 'text') {
      return '';
    }

    return marked(props.message.content.text || '');
  });

  const onOfferClick = offer => {
    if (props.message.content.type !== 'offers') {
      return;
    }

    if (!offer.search_query) {
      return;
    }

    router.push({
      name: 'OffersResults',
      params: {
        hashCode: offer.search_query,
        offerId: offer.id,
        source: 'chat',
      },
      query: { offerHash: offer.$meta.hash, back: 'chat' },
    });
  };

  const onTicketonClick = (ticketonItem: TicketonItem) => {
    if (!ticketonItem.deep_link) {
      return;
    }

    if (isOpenVariant.value) {
      freedomApp.lib.openMiniApp(
        SupportedMiniApps.TICKETON,
        ticketonItem.deep_link,
      );
    } else {
      freedomApp.lib.navigate(ticketonItem.deep_link);
    }
  };

  const formatTicketonStartsAt = (startsAt?: string) => {
    if (!startsAt) {
      return '-';
    }

    const normalizedDate = new Date(startsAt);
    if (Number.isNaN(normalizedDate.getTime())) {
      return startsAt;
    }

    return dateUtils.format(startsAt, 'D MMMM, HH:mm');
  };

  const formatTicketonPrice = (priceFromKzt?: number) => {
    if (typeof priceFromKzt !== 'number') {
      return t('aiChat.priceByRequest');
    }

    return t('general.price.startFrom', {
      price: priceFromKzt.toLocaleString('ru-RU'),
    });
  };

  const formatBudget = (value: number) => {
    return `~${value.toLocaleString('ru-RU')} ₸`;
  };

  const passengersCount = computed(() => {
    if (props.message.content.type !== 'trip_plan') {
      return 1;
    }

    const subtitle = props.message.content.plan.subtitle || '';
    const adultsMatch = subtitle.match(/(\d+)\s*(взросл|adult|ересек)/i);
    if (!adultsMatch) {
      return 1;
    }

    const parsedCount = Number(adultsMatch[1]);
    if (!Number.isFinite(parsedCount) || parsedCount < 1) {
      return 1;
    }

    return parsedCount;
  });

  const totalBudgetLabel = computed(() => {
    if (props.message.content.type !== 'trip_plan') {
      return '';
    }

    const totalBudgetKzt = props.message.content.plan.total_budget_kzt;
    if (typeof totalBudgetKzt !== 'number') {
      return '';
    }

    if (passengersCount.value > 1) {
      const familyBudget = totalBudgetKzt * passengersCount.value;
      return t('aiChat.totalBudgetFamily', {
        total: formatBudget(familyBudget),
        perPerson: formatBudget(totalBudgetKzt),
      });
    }

    return t('aiChat.totalBudgetSingle', {
      total: formatBudget(totalBudgetKzt),
    });
  });
</script>
